import dayjs from 'dayjs';
import is from 'is_js';

const expCachePrefix = '__wrapper__exp';
const objectCachePrefix = '__wrapper__object';

function wrap(
  _object,
  options = { exp: null, shelfLife: { value: null, unit: null } }
) {
  let exp = null;

  if (options?.exp != null) {
    exp = dayjs(options.exp);
  }

  if (exp != null || options?.shelfLife?.value > 0) {
    if (!exp?.isValid()) {
      exp = dayjs().add(
        options?.shelfLife.value,
        options?.shelfLife.unit ?? 'm'
      );
    }

    const result = {};
    result[objectCachePrefix] = _object;
    result[expCachePrefix] = exp.toISOString();

    return result;
  }

  return _object;
}

function unwrap(_object) {
  if (isWrapped(_object)) {
    const diff = dayjs().diff(dayjs(_object[expCachePrefix]));
    return diff < 0 ? _object[objectCachePrefix] : null;
  }

  return _object;
}

function isWrapped(_object) {
  return is.propertyDefined(_object, objectCachePrefix);
}

export { isWrapped, unwrap, wrap };
